import type { ApiClient } from '@klareospace/pharos-lib-front-utils';
import type { PharosApiResponse, UpsertUserPreference } from '@klareospace/pharos-lib-types';
import type { UserPreference } from '@klareospace/pharos-lib-types';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface SearchUserPreferencesParams {
  keys?: string[];
}

// ─── API Factory ──────────────────────────────────────────────────────────────

export function createUserPreferenceApi(client: ApiClient): {
  searchUserPreferences: (params: SearchUserPreferencesParams) => Promise<UserPreference[]>;
  upsertUserPreference: (input: UpsertUserPreference) => Promise<UserPreference>;
} {
  return {
    searchUserPreferences: async (params: SearchUserPreferencesParams): Promise<UserPreference[]> => {
      const response = await client.execute<PharosApiResponse<UserPreference[]>>(() =>
        client.instance.post('/user-preferences/search', params),
      );
      if (!response.data) {
        throw new Error('Unexpected empty response from API');
      }
      return response.data;
    },

    upsertUserPreference: async (input: UpsertUserPreference): Promise<UserPreference> => {
      const response = await client.execute<PharosApiResponse<UserPreference>>(() =>
        client.instance.put('/user-preferences', input),
      );
      if (!response.data) {
        throw new Error('Unexpected empty response from API');
      }
      return response.data;
    },
  };
}
